import MUITooltip from "@mui/material/Tooltip";

const Tooltip = MUITooltip;

export default Tooltip;
